import React from 'react';
import { Link } from 'react-router-dom';
import '../css/applications_page.css';
const applications = [
    {
        title: 'Content Creator',
        link: '/apply/content-creator',
        image: 'https://cdn.ballhead.app/web_assets/CC_LOGO.png',
    },
    {
        title: 'True Baller',
        link: '/apply/true-baller',
        image: 'https://cdn.ballhead.app/web_assets/TB_LOGO.png',
    },
];

export default function ApplicationsPage() {
    return (
        <div className="applications-page">
            {applications.map(({ title, link, image }) => (
                <div key={title} className="application-card">
                    <img src={image} alt={title} className="application-image" />
                    <h2 className="application-title">{title}</h2>
                    <Link to={link} className="apply-button">Apply</Link>
                </div>
            ))}
        </div>
    );
}
